export const Modal = function (content, classes) {

		return `<div id="sub-overlay" class="sub-modal ${classes ?? ''}" style="display: none">
	           ${content}
	        </div>`;

}

var closeModal = function () {
	$('.sub-modal').hide();
}

$(document).on('click', '.sub-exit', function (e) {
	e.preventDefault();
	closeModal();
});

$(document).on('keyup',function (e) {
	if (e.key === 'Escape') {
		e.preventDefault();
		closeModal();
	}
})

$(document).on('click', '#sub-overlay', function () {
	closeModal();
})

$(document).on('click', '#sub-overlay form, #sub-overlay .sub-order-box', function (e) {
	e.stopImmediatePropagation()
});

